import type { TournamentState } from "../../../../engine/types";
import { SLIDE_COUNT, SLIDE_TITLES } from "../../lib/slides";
import type { TabProps } from "./common";

/**
 * The slides before round 1, from the owner's phone only (the server refuses `slides.set` from
 * anyone else). Shown before round 1, and while the slides are on.
 */
export function slidesCardShown(t: TabProps["t"], state: TournamentState): boolean {
  const owner = t.identity?.role === "admin" && t.identity.owner !== false;
  return owner && (state.rounds.length === 0 || typeof state.slides === "number");
}

export function SlidesCard({ t, state }: Pick<TabProps, "t" | "state">) {
  const slide = typeof state.slides === "number" ? state.slides : null;
  const go = (to: number | null) => t.send({ type: "slides.set", slide: to });
  if (slide === null) {
    return (
      <section className="ad-card ad-slides">
        <h2>Slides</h2>
        <button type="button" className="btn accent ad-wide ad-slides-key" onClick={() => go(0)}>
          Show the slides
        </button>
        <p className="ad-note">A few slides on the wall before round 1. Only your phone moves them.</p>
      </section>
    );
  }
  return (
    <section className="ad-card ad-slides on">
      <h2>Slides</h2>
      <div className="ad-slides-now" role="status">
        <b>{SLIDE_TITLES[slide] ?? ""}</b>
        <span>Slide {slide + 1} of {SLIDE_COUNT}</span>
      </div>
      <div className="ad-grid2">
        <button type="button" className="btn ad-slides-key" disabled={slide <= 0} onClick={() => go(slide - 1)}>
          Back
        </button>
        <button type="button" className="btn accent ad-slides-key" disabled={slide >= SLIDE_COUNT - 1} onClick={() => go(slide + 1)}>
          Next
        </button>
      </div>
      <button type="button" className="btn quiet ad-wide" onClick={() => go(null)}>
        End the slides
      </button>
      <p className="ad-note">Ending puts the wall back. Start round 1 from here when you are ready.</p>
    </section>
  );
}
